module.exports = __webpack_public_path__ + "static/media/DiscountMags.99efafc4.jpg";